exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".custom-file-input,.custom-file-label,input[type=file]{border-radius:4px!important}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/category/BaseForm.vue"],"names":[],"mappings":"AACA,uDACE,2BAA8B,CAC/B","file":"BaseForm.vue","sourcesContent":["\ninput[type='file'], .custom-file-input, .custom-file-label {\n  border-radius: 4px !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e494d010","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/admin/category/BaseForm.vue
// module id = 2217
// module chunks = 0